module.exports = __webpack_public_path__ + "img/calendar.9cca95a7.svg";